// Semantic aliases into styles/typography.css through Tailwind. Do not add metrics here.
export const HEADLINE = "text-ui-headline font-semibold leading-snug";
export const HEADLINE_AT_DESKTOP = "desktop:text-ui-headline desktop:font-semibold desktop:leading-snug";
export const CARD_TITLE = "text-ui-card-title font-semibold leading-snug";
export const SECTION_TITLE = "text-ui-section font-bold";
export const TITLE = "text-ui-title font-bold leading-tight";
export const SUBTITLE = "text-ui-card-title text-muted-foreground";
export const ROW_TITLE = "text-ui-secondary-copy font-semibold leading-snug";
export const ROW_TEXT = "text-ui-secondary-copy";
export const META = "text-ui-control text-muted-foreground";
export const CAPTION = "text-ui-caption text-muted-foreground";
export const LABEL = "text-ui-caption font-medium";
export const CONTROL = "text-ui-control font-semibold";
export const CTA = "text-ui-field font-semibold";
export const ERROR = "text-ui-caption text-destructive";
